<template>
    <div class="plan">
        <div class="plan_card_container white-box plan-selection__plan text-black" v-if="portfolio.investmentType !== 'manual'">
                <div class="ribbon ribbon-top-right">
                    <span>Selected</span>
                </div>
                <div>
                    <span
                    style="color: #9e9e9e; font-weight: 500"
                    class="font-size-md"
                    >Earn upto</span
                    >
                </div>
                <div>
                    <span style="font-size: 36px; color: #232323; font-weight: 700"
                    >{{planPercentage}}%</span
                    >
                    <span
                    style="color: #232323; font-weight: 400; padding-left: 1px"
                    class="font-size-base"
                    >per annum</span
                    >
                </div>
                <div>
                    <span style="text-transform: capitalize; font-size: 18px; color: #002fa7; font-weight: 800"
                    >{{portfolio.planType}} </span
                    >
                    <span style="text-transform: capitalize; font-size: 18px; color: #002fa7; font-weight: 800"
                    >{{portfolio.riskProfile}}</span
                    >
                </div>
                <div>
                    <span class = "tenure_text">
                        <v-icon class="material-icons tenure_text"> lock </v-icon>
                        Lock-in 12 Months
                    </span>
                </div>
        </div>
        <div class="white-box plan-selection__plan text-black" v-else>
            <div class="choose-plan-headWrap">
                <strong class="title">
                    Manual Investment
                </strong>

            </div>
            <div class="portfolioInfo">
                You have chosen.....
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlanCard',
    props: {
        selectedPlan: Object,
        portfolio: Object
    },
    computed: {
        planPercentage () {
            let percentage = 0
            if (this.portfolio.planType === 'growth' && this.portfolio.riskProfile === 'aggressive') {
                percentage = 18
            } else if (this.portfolio.planType === 'growth' && this.portfolio.riskProfile === 'conservative') {
                percentage = 14
            } else if (this.portfolio.planType === 'income' && this.portfolio.riskProfile === 'aggressive') {
                percentage = 16
            } else if (this.portfolio.planType === 'income' && this.portfolio.riskProfile === 'conservative') {
                percentage = 12
            }
            return percentage
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./planCard.scss";

@media (max-width: 990px) {
    .plan_card_container {
        position: relative !important
    }
    .ribbon-top-right {
    right: 0px !important;
    bottom: 8px !important;
    }
}

.plan_card_container {
    position: relative !important
}
.tenure_text {
    font-weight: 400;
    font-size: 13px;
    color: #8C8C8C;

}
.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #002FA7;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 260px;
  padding: 7px 0;
  background-color: #002FA7;
  box-shadow: 0 2px 1px rgba(0,0,0,.1);
  color: #fff;
  font: 500 16px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-align: center;
}

/* top right*/
.ribbon-top-right {
    right: 0px;
    bottom: 17px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 22px;
}
.ribbon-top-right::after {
  bottom: 22px;
  right: 0;
}
.ribbon-top-right span {
  left: -27px;
  top: 29px;
  transform: rotate(45deg);
}
</style>
